import { render, staticRenderFns } from "./UserExamRecent.vue?vue&type=template&id=33fa338d"
import script from "./UserExamRecent.vue?vue&type=script&lang=js"
export * from "./UserExamRecent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports